export default function(enable) {

    this._options.convertEqualSidedPolygons = enable;

    return this;
};
